import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'next-i18next';

import { IOrder } from '../../../lib/ssp/types';
import { getDayJS } from '../../../lib/utils/date';

import { Container, Date, Title } from './styled';

export type OrderTitleProps = {
  order: IOrder;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const OrderTitle: React.FC<OrderTitleProps> = ({ order, onClick }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title onClick={onClick}>
        {t('orderNumber', { orderNumber: order.name })}
      </Title>
      <Date className="date">{getDayJS(order.created_at).format('L')}</Date>
    </Container>
  );
};

export default OrderTitle;
